export default __webpack_public_path__ + "static/media/iconPlusWhite.5edba3aa.svg";